<template>
    <notifications group="notifications" position="top right" classes="vue-notification-template vue-notification "/>
</template>

<script>

import Vue from 'vue'
import _ from 'lodash'
import Notifications from 'vue-notification'

Vue.use(Notifications)

// vue-notification muestra `text` como HTML (v-html). Lo que llega a estos
// avisos —mensajes del servidor, nombres, parámetros de la URL— se escapa:
// se lee como texto y nunca se interpreta como markup.
function escapeText (value) {
    return _.escape(value === null || value === undefined ? '' : String(value))
}

function errorText (error) {
    const response = error && error.response
    if (!response) {
        return 'No se pudo comunicar con el servidor.'
    }

    const data = response.data || {}

    // 422 de validación: un renglón por campo. El <br> es el único markup y lo
    // agrega este componente.
    if (response.status === 422 && data.errors && typeof data.errors === 'object') {
        return Object.values(data.errors)
            .map(messages => escapeText(Array.isArray(messages) ? messages[0] : messages) + '<br>')
            .join('')
    }

    const message = typeof data.message === 'string' && data.message !== '' ? data.message : 'Error inesperado del servidor.'

    return '[' + response.status + '] ' + escapeText(message)
}

export default {
    name: 'notifications-component',

    mounted () {
        let $this = this

        // Axios interceptors for showing messages
        this.axios.interceptors.response.use(function (response) {
            // $this.$eventHub.$emit('notifySuccess', response)
            return response
        }, function (error) {
            // Un pedido que presenta sus propios errores lo declara con `notifyOnError: false`.
            if (error.config && error.config.notifyOnError === false) return Promise.reject(error)
            if (!error.request.responseURL.includes('login')) $this.$eventHub.$emit('notifyError', error)
            return Promise.reject(error)
        })

        this.$eventHub.$on('notifySuccess', this.notifySuccess)
        this.$eventHub.$on('notifyWarning', this.notifyWarning)
        this.$eventHub.$on('notifySecondary', this.notifySecondary)
        this.$eventHub.$on('notifyError', this.notifyError)
        this.$eventHub.$on('notifyCustomError', this.notifyCustomError)
    },

    methods: {

        notifySuccess (data) {
            this.$notify({
                group: 'notifications',
                title: 'Correcto',
                type: 'success',
                text: escapeText(data)
            })
        },

        notifyWarning (data) {
            this.$notify({
                group: 'notifications',
                title: 'Atención',
                duration: 3000,
                type: 'warning',
                text: escapeText(data)
            })
        },

        notifySecondary (data) {
            this.$notify({
                group: 'notifications',
                title: 'Información',
                type: 'secondary',
                text: escapeText(data)
            })
        },

        notifyCustomError (data) {
            this.$notify({
                group: 'notifications',
                title: 'Acción requerida',
                type: 'danger',
                duration: 10000,
                text: escapeText(data)
            })
        },

        notifyError (error) {
            this.$notify({
                group: 'notifications',
                title: 'Error',
                type: 'bg-danger text-white',
                duration: 3000,
                text: errorText(error)
            })
        }
    }

}
</script>
